import { ReactElement } from "react";
import { SecondmentDetail } from "../../../Services/PublicSecondments";
import { firmProfilePath, logoUrl } from "../secondmentsDisplay";
import SecondmentsTabs from "./SecondmentsTabs";

interface SecondmentsOverviewProps {
  detail: SecondmentDetail;
}

export default function SecondmentsOverview({ detail }: SecondmentsOverviewProps): ReactElement {
  return (
    <section id="view">
      <h2 className="secondments-heading">Overview</h2>
      <article className="secondments-card">
        <div className="secondments-card-grid">
          <a href={firmProfilePath(detail.companyType, detail.companyNameSlug, detail.firmId)}>
            {detail.logoName ? <img className="secondments-logo" src={logoUrl(detail.logoName)} alt="" /> : null}
          </a>
          <div>
            <p className="secondments-label">Secondment Program Overview:</p>
            <p>{detail.programOverview}</p>
          </div>
        </div>
      </article>
      {detail.secId > 0 ? (
        <p>
          <span className="secondments-label">{detail.positionTitle}</span>
          <br />
          <strong>Location</strong>: {detail.location}
        </p>
      ) : null}
      <SecondmentsTabs secId={detail.secId} firmId={detail.firmId} active="view" posting={detail.secId > 0} />
      <p>{detail.description}</p>
      {detail.requirements ? <p><span className="secondments-label">Position Requirements:</span> {detail.requirements}</p> : null}
      <p><span className="secondments-label">Secondment Duration:</span> {detail.duration}</p>
      <p><span className="secondments-label">Application Deadline:</span> {detail.deadline}</p>
      <p><span className="secondments-label">Practice Areas:</span> {detail.practices}</p>
      {detail.applicationInfo ? <p><span className="secondments-label">Additional Information:</span> {detail.applicationInfo}</p> : null}
      <img className="secondments-dots" src="https://members-legacy.worldservicesgroup.com/assets/images/dots.png" alt="dots" />
    </section>
  );
}
